import { CommonModule } from '@angular/common';
import { Component, TemplateRef, input } from '@angular/core';

import { CardContent } from '@/shared/components/card-content/card-content';

@Component({
    selector: 'app-painel-comissoes',
    standalone: true,
    imports: [CommonModule, CardContent],
    templateUrl: './painel-comissoes.html',
    styleUrls: ['./painel-comissoes.scss']
})
export class PainelComissoesContainer {
    readonly tituloPainel = input.required<string>();
    readonly descricaoPainel = input<string>('');
    readonly iconePainel = input<string>('');
    readonly filtrosTemplate = input.required<TemplateRef<unknown>>();
    readonly conteudoTemplate = input.required<TemplateRef<unknown>>();
    readonly ocultarFiltros = input<boolean>(false);
}
